// extracted by mini-css-extract-plugin
export default {"container":"Contracts_container__pAvMY","box":"Contracts_box__cC-Ob","table":"Contracts_table__e4eN9","button":"Contracts_button__DgXVm"};